import axios from "axios";
import React, { useEffect, useState } from "react";
import { AUTH, AUTHH, BASE_URL, IMAGE_URL } from "../../config/axios";
import { toast, ToastContainer } from "react-toastify";
import { formatDate, formattedDateLong } from "../Date";
import { Modal } from "react-bootstrap";
import Dashboardnavbar from "../../layout/Dashboardnavbar";
import { useNavigate } from "react-router-dom";
import {
    formatCurrencyIndian,
    formatDateTime,
    formatRoundoff2D,
    handleErrorToast,
    ViewRequestRemarks,
    ViewRequestStatus,
    getMonthName,
} from "../CustomFunctions";
import usePermission from "../../config/permissions";
import {
    CheckGreen,
    WarnYellow,
    Eye,
    Filter,
    Office,
    CrossRed,
    Attachment,
    Employee,
    CircularGrid,
    SelectVehical,
} from "../AllSvg";
import { Projects } from "../FilterDropdown";
import {
    ApproveRequestVehicleBillingChecker,
    RejectRequestVehicleBillingChecker,
    ApproveRequestVehicleBillingAuthority,
    RejectRequestVehicleBillingAuthority,
    ApproveRequestVehicleBillingAccStage1,
    RejectRequestVehicleBillingAccStage1,
    ApprovedVehicleBillingAdminC1,
    ApprovedVehicleBillingAdminC2,
    ApprovedVehicleBillingAdminC3,
    RejectVehicleBillingAdminC1,
    RejectVehicleBillingAdminC2,
    RejectVehicleBillingAdminC3,
    ApproveRequestVehicleBillingAccStage2,
    RejectRequestVehicleBillingAccStage2,
} from "./VehicleBillingActionButton";
import { DownloadVehicleBill } from "../SiteManagement/VehicleManagement/VehicleManagementComponenets";
const RequestVehicleBillingChecker = () => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };
    const [vehicle, setVehicle] = useState("null");
    //! ******************************API start***************************//
    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/vehiclebillingapicheckerfilter/${selectedProject}/${selectedStatus}/${fromdate}/${vehicle}/`
            );
            if (res?.data?.bills) {
                setOfficeBillings(res.data.bills);
            } else {
                setOfficeBillings(res.data);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };
    const [vehicleList, setVehicleList] = useState([]);
    const getVehicle = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehicle-short/`);
            setVehicleList(veh.data);

        } catch (err) {
            //toast Logic
            if (err.response) {
                const errorData = err.response.data;

                if (typeof errorData.error === 'string') {
                    // Single error message
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    // Multiple error messages
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        } finally {
            setBuffering(false);// End Buffering
        }
    }
    useEffect(() => {
        getofficebillingdata();
        getSubCompany();

    }, [fromdate, todate, selectedStatus, vehicle, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getEmpcode();
        getVehicle();
    }, []);
    //! *********** Employee Details Api End ***********

    return (
        <>
            <Dashboardnavbar
                name={"Vehicle Billing Checker"}
                url="Vehicle Billing Checker"
            />
            <div className="content-tabs">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <div className="attendance-history-cont">
                    <div className="attendance-heading  font-weight500    font-size-heading">
                        {" "}
                    </div>
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            <div className="field-cont-div">
                                <div className="date-uppercase ">
                                    <input
                                        className="attendance-input-field width-10vw   date-field date-field-filter"
                                        placeholder="From Date"
                                        type="date"
                                        value={fromdate}
                                        onChange={(e) =>
                                            setFromDate(
                                                e.target.value === "" ? "null" : e.target.value
                                            )
                                        }
                                    />
                                </div>

                                <hr className="field-cont-hr" />
                            </div>

                            {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Office />
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    type="text"
                                    value={selectedDivision}
                                    onChange={(e) => setDivision(e.target.value)}
                                >
                                    <option value="null">All Sub Companies</option>
                                    {SubCompany.sort((a, b) => a.title - b.title).map(
                                        (i, index) => (
                                            <option value={i.id}>{i.title}</option>
                                        )
                                    )}
                                    ;
                                </select>

                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
                            </div>
                            <div title="Vehicle Filter" className="field-cont-div ">
                                <CircularGrid />
                                <select
                                    id="vehicle"
                                    name="vehicle"
                                    placeholder="vehicle"
                                    value={vehicle}
                                    onChange={(e) => setVehicle(e.target.value)}
                                    className={`attendance-input-field width-10vw`}
                                >

                                    <option value="null">Select Vehicle</option>
                                    {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.id}>{i.name}-{i.vehicle_num}</option>
                                    ))}
                                </select>


                            </div>
                        </div>
                        <div className="btn-cont"></div>
                    </div>

                    <div className="table-css-white-background scroll-container-table">
                        {/* <div className="table-heading-flex">
                        <div className="repo-heading font-weight500    font-size-heading">Expense</div>
                        <div className="flex-row">
                        </div>
                    </div> */}
                        <table className="table-css">
                            <thead className="table-heading stciky-heading-top">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text text-left-sr">S.No.</th>
                                    <th className="table-heading-text">Project Name</th>
                                    <th className="table-heading-text">Vehicle Name</th>
                                    <th className="table-heading-text">Vehicle Number</th>
                                    <th className="table-heading-text">Date</th>
                                    <th className="table-heading-text">Days</th>
                                    <th className="table-heading-text">Months</th>
                                    <th className="table-heading-text">Year</th>
                                    <th className="table-heading-text">Fixed Kilometer</th>
                                    <th className="table-heading-text">Fixed Bill Amount</th>
                                    <th className="table-heading-text text-center ">
                                        Extra Amount Per KM <br /> After Fixed KM
                                    </th>
                                    <th className="table-heading-text">Status</th>
                                    <th className="table-heading-text">Remarks</th>
                                    <th className="table-heading-text text-center">Actions</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner"></div>
                            ) : (
                                <tbody>
                                    {officeBillings !== undefined &&
                                        officeBillings.map((i, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="custom-table-head-td">
                                                    <td className="table-body text-left-sr">
                                                        {index + 1}
                                                    </td>
                                                    <td className="table-body">
                                                        {i?.vehicle_details?.project_short_name}
                                                    </td>
                                                    <td className="table-body">{i.vehicle_name}</td>
                                                    <td className="table-body">{i.vehicle_num}</td>
                                                    <td className="table-body">
                                                        {i.date ? formatDate(i.date) : "-"}
                                                    </td>
                                                    <td className="table-body">{i.days}</td>
                                                    <td className="table-body">
                                                        {getMonthName(i.month)}
                                                    </td>
                                                    <td className="table-body">{i.year}</td>
                                                    <td className="table-body text-center">
                                                        {i.fixed_km}
                                                    </td>
                                                    <td className="table-body text-center">
                                                        {formatCurrencyIndian(i.fixed_bill_amt)}
                                                    </td>
                                                    <td className="table-body text-center">
                                                        {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                                    </td>
                                                    <ViewRequestStatus
                                                        i={i}
                                                        approval_stages_data={i?.approval_stages_data}
                                                    />

                                                    <ViewRequestRemarks
                                                        i={i}
                                                        table="vehicle"
                                                        approval_stages_data={i?.approval_stages_data}
                                                    />
                                                    <td className="table-body">
                                                        {i?.approval_stages_data?.checker && (
                                                            <div className="flex-row ">
                                                                <>
                                                                    {i.checker_approval_status === "approved" ? (
                                                                        <></>
                                                                    ) : (
                                                                        <ApproveRequestVehicleBillingChecker
                                                                            i={i}
                                                                            getofficebillingdata={
                                                                                getofficebillingdata
                                                                            }
                                                                            documentlist={
                                                                                i?.vehicle_details?.documents
                                                                            }
                                                                        />
                                                                    )}
                                                                </>
                                                                <>
                                                                    {i.checker_approval_status === "rejected" ? (
                                                                        <></>
                                                                    ) : (
                                                                        <RejectRequestVehicleBillingChecker
                                                                            i={i}
                                                                            getofficebillingdata={
                                                                                getofficebillingdata
                                                                            }
                                                                            documentlist={
                                                                                i?.vehicle_details?.documents
                                                                            }
                                                                        />
                                                                    )}
                                                                </>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

const RequestVehicleBillingAuthority = (showdashboard) => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );
    const [vehicle, setVehicle] = useState("null");
    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    //! ******************************API start***************************//
    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/vehiclebillingapiauthorityfilter/${sessionStorage.getItem(
                    "sitemanagement_emp_id"
                )}/${selectedProject}/${selectedStatus}/${fromdate}/${vehicle}/`
            );
            if (res?.data?.bills) {
                setOfficeBillings(res.data.bills);
            } else {
                setOfficeBillings(res.data);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getofficebillingdata();
        getSubCompany();
    }, [fromdate, todate, selectedStatus, vehicle, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const [vehicleList, setVehicleList] = useState([]);
    const getVehicle = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehicle-short/`);
            setVehicleList(veh.data);

        } catch (err) {
            //toast Logic
            if (err.response) {
                const errorData = err.response.data;

                if (typeof errorData.error === 'string') {
                    // Single error message
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    // Multiple error messages
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        } finally {
            setBuffering(false);// End Buffering
        }
    }

    useEffect(() => {
        getEmpcode();
        getVehicle();
    }, []);
    //! *********** Employee Details Api End ***********

    return (
        <>
            {
                showdashboard?.showdashboard === "false" ? (
                    <></>
                ) : (
                    <Dashboardnavbar name={"Admin Office Billing"} url="Admin Office Billing" />
                )
            }
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className={showdashboard.showdashboard === "false" ? "" : "content-tabs"}>
                <div className="attendance-history-cont">
                    <div className="attendance-heading  font-weight500    font-size-heading">
                        {" "}
                    </div>
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            <div className="field-cont-div">
                                <div className="date-uppercase ">
                                    <input
                                        className="attendance-input-field width-10vw   date-field date-field-filter"
                                        placeholder="From Date"
                                        type="date"
                                        value={fromdate}
                                        onChange={(e) =>
                                            setFromDate(
                                                e.target.value === "" ? "null" : e.target.value
                                            )
                                        }
                                    />
                                </div>

                                <hr className="field-cont-hr" />
                            </div>

                            {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Office />
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    type="text"
                                    value={selectedDivision}
                                    onChange={(e) => setDivision(e.target.value)}
                                >
                                    <option value="null">All Sub Companies</option>
                                    {SubCompany.sort((a, b) => a.title - b.title).map(
                                        (i, index) => (
                                            <option value={i.id}>{i.title}</option>
                                        )
                                    )}
                                    ;
                                </select>

                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
                            </div>
                            <div title="Vehicle Filter" className="field-cont-div ">
                                <CircularGrid />
                                <select
                                    id="vehicle"
                                    name="vehicle"
                                    placeholder="vehicle"
                                    value={vehicle}
                                    onChange={(e) => setVehicle(e.target.value)}
                                    className={`attendance-input-field width-10vw`}
                                >

                                    <option value="null">Select Vehicle</option>
                                    {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.id}>{i.name}-{i.vehicle_num}</option>
                                    ))}
                                </select>


                            </div>
                        </div>
                        <div className="btn-cont"></div>
                    </div>

                    <div className="table-css-white-background scroll-container-table">
                        {/* <div className="table-heading-flex">
                        <div className="repo-heading font-weight500    font-size-heading">Expense</div>
                        <div className="flex-row">
                        </div>
                    </div> */}
                        <table className="table-css">
                            <thead className="table-heading stciky-heading-top">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text text-left-sr">S.No.</th>
                                    <th className="table-heading-text">Project Name</th>
                                    <th className="table-heading-text">Vehicle Name</th>
                                    <th className="table-heading-text">Vehicle Number</th>
                                    <th className="table-heading-text">Date</th>
                                    <th className="table-heading-text">Days</th>
                                    <th className="table-heading-text">Months</th>
                                    <th className="table-heading-text">Year</th>
                                    <th className="table-heading-text">Fixed Kilometer</th>
                                    <th className="table-heading-text">Fixed Bill Amount</th>
                                    <th className="table-heading-text text-center ">
                                        Extra Amount Per KM <br /> After Fixed KM
                                    </th>
                                    <th className="table-heading-text">Status</th>
                                    <th className="table-heading-text">Remarks</th>
                                    <th className="table-heading-text text-center">Actions</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner"></div>
                            ) : (
                                <tbody>
                                    {officeBillings !== undefined &&
                                        officeBillings.map((i, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="custom-table-head-td">
                                                    <td className="table-body text-lefttt">
                                                        {index + 1}
                                                    </td>
                                                    <td className="table-body">
                                                        {i?.vehicle_details?.project_short_name}
                                                    </td>
                                                    <td className="table-body">{i.vehicle_name}</td>
                                                    <td className="table-body">{i.vehicle_num}</td>
                                                    <td className="table-body">
                                                        {i.date ? formatDate(i.date) : "-"}
                                                    </td>
                                                    <td className="table-body">{i.days}</td>
                                                    <td className="table-body">
                                                        {getMonthName(i.month)}
                                                    </td>
                                                    <td className="table-body">{i.year}</td>
                                                    <td className="table-body text-center">
                                                        {i.fixed_km}
                                                    </td>
                                                    <td className="table-body text-center">
                                                        {formatCurrencyIndian(i.fixed_bill_amt)}
                                                    </td>
                                                    <td className="table-body text-center">
                                                        {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                                    </td>
                                                    <ViewRequestStatus
                                                        i={i}
                                                        approval_stages_data={i?.approval_stages_data}
                                                    />

                                                    <ViewRequestRemarks
                                                        i={i}
                                                        table="vehicle"
                                                        approval_stages_data={i?.approval_stages_data}
                                                    />
                                                    <td className="table-body">
                                                        {i?.approval_stages_data?.authority && (
                                                            <div className="flex-row ">
                                                                <>
                                                                    {i.authority_approval_status ===
                                                                        "approved" ? (
                                                                        <></>
                                                                    ) : (
                                                                        <ApproveRequestVehicleBillingAuthority
                                                                            i={i}
                                                                            getofficebillingdata={
                                                                                getofficebillingdata
                                                                            }
                                                                            documentlist={
                                                                                i?.vehicle_details?.documents
                                                                            }
                                                                        />
                                                                    )}
                                                                </>
                                                                <>
                                                                    {i.authority_approval_status ===
                                                                        "rejected" ? (
                                                                        <></>
                                                                    ) : (
                                                                        <RejectRequestVehicleBillingAuthority
                                                                            i={i}
                                                                            getofficebillingdata={
                                                                                getofficebillingdata
                                                                            }
                                                                            documentlist={
                                                                                i?.vehicle_details?.documents
                                                                            }
                                                                        />
                                                                    )}
                                                                </>
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

const RequestVehicleBillingAdmin = (showdashboard) => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedStatustwo, setSelectedStatustwo] = useState("");
    const [selectedStatus3, setSelectedStatus3] = useState("");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");

    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );
    const [vehicle, setVehicle] = useState("null");
    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    //! ******************************API start***************************//
    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            let url;
            // if (sessionStorage.getItem("email") === "manoj.rathi@saptagon.in") {
            //     url = `${BASE_URL}/siteproject/vehiclebillingapiadminc1filter/${selectedStatus}/${fromdate}/${todate}/${vehicle}/`;
            // } else if (
            //     sessionStorage.getItem("email") === "megha.garg@g-eng.in" ||
            //     sessionStorage.getItem("email") === "abhishekprakash489@gmail.com"
            // ) {
            //     url = `${BASE_URL}/siteproject/vehiclebillingapiadminc2filter/${selectedStatus}/${fromdate}/${todate}/${vehicle}/`;
            // } 
            // else {
            url = `${BASE_URL}/siteproject/vehiclebillingapiadminc1filter/${selectedProject}/${selectedStatus}/${fromdate}/${todate}/${vehicle}/`;
            // }
            const res = await axios.get(url);

            if (res?.data?.bills) {
                setOfficeBillings(res.data.bills);
            } else {
                setOfficeBillings(res.data);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const getofficebillingdata2 = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            let url;
            // if (sessionStorage.getItem("email") === "manoj.rathi@saptagon.in") {
            //     url = `${BASE_URL}/siteproject/vehiclebillingapiadminc1filter/${selectedStatus}/${fromdate}/${todate}/${vehicle}/`;
            // } else if (
            //     sessionStorage.getItem("email") === "megha.garg@g-eng.in" ||
            //     sessionStorage.getItem("email") === "abhishekprakash489@gmail.com"
            // ) {
            //     url = `${BASE_URL}/siteproject/vehiclebillingapiadminc2filter/${selectedStatus}/${fromdate}/${todate}/${vehicle}/`;
            // } 
            // else {
            url = `${BASE_URL}/siteproject/vehiclebillingapiadminc2filter/${selectedProject}/${selectedStatus}/${fromdate}/${todate}/${vehicle}/`;
            // }
            const res = await axios.get(url);

            if (res?.data?.bills) {
                setOfficeBillings(res.data.bills);
            } else {
                setOfficeBillings(res.data);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const getofficebillingdata3 = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            let url;
            // if (sessionStorage.getItem("email") === "manoj.rathi@saptagon.in") {
            //     url = `${BASE_URL}/siteproject/vehiclebillingapiadminc1filter/${selectedStatus}/${fromdate}/${todate}/${vehicle}/`;
            // } else if (
            //     sessionStorage.getItem("email") === "megha.garg@g-eng.in" ||
            //     sessionStorage.getItem("email") === "abhishekprakash489@gmail.com"
            // ) {
            //     url = `${BASE_URL}/siteproject/vehiclebillingapiadminc2filter/${selectedStatus}/${fromdate}/${todate}/${vehicle}/`;
            // } 
            // else {
            url = `${BASE_URL}/siteproject/vehiclebillingapiadminc3filter/${selectedProject}/${selectedStatus}/${fromdate}/${todate}/${vehicle}/`;
            // }
            const res = await axios.get(url);

            if (res?.data?.bills) {
                setOfficeBillings(res.data.bills);
            } else {
                setOfficeBillings(res.data);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        if (selectedStatustwo !== "") {
            getofficebillingdata2()
            getSubCompany();
        }
    }, [selectedStatustwo])

    useEffect(() => {
        if (selectedStatus3 != "") {
            console.log("useefect running", selectedStatus3)
            getofficebillingdata3()
            getSubCompany();
        }
    }, [selectedStatus3])
    useEffect(() => {
        getofficebillingdata();
        getSubCompany();
    }, [fromdate, todate, selectedStatus, vehicle, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const [vehicleList, setVehicleList] = useState([]);
    const getVehicle = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehicle-short/`);
            setVehicleList(veh.data);

        } catch (err) {
            //toast Logic
            if (err.response) {
                const errorData = err.response.data;

                if (typeof errorData.error === 'string') {
                    // Single error message
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    // Multiple error messages
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        } finally {
            setBuffering(false);// End Buffering
        }
    }
    useEffect(() => {
        getEmpcode();
        getVehicle();
    }, []);
    //! *********** Employee Details Api End ***********

    // multiple code

    const [checkedItems, setCheckedItems] = useState([]);
    const handleCheckboxChange = (id) => {
        const currentIndex = checkedItems.indexOf(id);
        const newCheckedItems = [...checkedItems];

        if (currentIndex === -1) {
            newCheckedItems.push(id);
        } else {
            newCheckedItems.splice(currentIndex, 1);
        }
        setCheckedItems(newCheckedItems);
    };

    const updatedate = checkedItems.map((status) => {
        return {
            checker_approval_status: "approved",

            checker_update_datetime: new Date().toISOString(),
            account_status_a: "approved",
            account_update_datetime: new Date().toISOString(),
            account_status_b: "approved",

            final_update_datetime: new Date().toISOString(),
            admin_approval_status_c1: "approved",
            admin_update_datetime_c1: new Date().toISOString(),
            admin_approval_status_c2: "approved",
            admin_update_datetime_c2: new Date().toISOString(),
            authority_approval_status: "approved",
            admin_update_by_c2: sessionStorage.getItem("sitemanagement_emp_code"),
            admin_update_by_c1: sessionStorage.getItem("sitemanagement_emp_code"),
            // authority_engineer: sessionStorage.getItem('sitemanagement_emp_code'),
        };
    });

    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmitApprovePut = async (e) => {
        e.preventDefault();
        setLoading(true); //loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.put(
                `${BASE_URL}/siteproject/officebillingbulkapprovalAPI/`,
                updatedate
            );

            if (res.status === 200) {
                setCheckedItems([]);
                await getofficebillingdata();
                // setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            if (err.response) {
                toast.dismiss(loadingToastId);
                const errorData = err.response.data;

                if (typeof errorData.error === "string") {
                    // Single error message
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === "object" && errorData !== null) {
                    // Multiple error messages
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach((message) =>
                            toast.error(`"${field}": ${message}`)
                        );
                    });
                } else {
                    toast.error("Error:- Failed to Process!");
                }
            } else {
                toast.error("Error processing your request.");
            }
        } finally {
            setLoading(false); //loading logic
            toast.dismiss(loadingToastId);
        }
    };
    // const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedRhStatus, setSelectedRHStatus] = useState("approved");
    return (
        <>
            {
                showdashboard?.showdashboard === "false" ? (
                    <></>
                ) : (
                    <Dashboardnavbar name={"Admin Office Billing"} url="Admin Office Billing" />
                )
            }

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className={showdashboard.showdashboard === "false" ? "" : "content-tabs"}>
                <div className="attendance-history-cont">
                    <div className="attendance-heading  font-weight500    font-size-heading">
                        {" "}
                    </div>
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            <div className="field-cont-div">
                                <div className="date-uppercase ">
                                    <input
                                        className="attendance-input-field width-10vw   date-field date-field-filter"
                                        placeholder="From Date"
                                        type="date"
                                        value={fromdate}
                                        onChange={(e) =>
                                            setFromDate(
                                                e.target.value === "" ? "null" : e.target.value
                                            )
                                        }
                                    />
                                </div>

                                <hr className="field-cont-hr" />
                            </div>

                            {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatus}
                                    onChange={(e) => setSelectedStatus(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div" title="admin2">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatustwo}
                                    onChange={(e) => setSelectedStatustwo(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div" title="admin3">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedStatus3}
                                    onChange={(e) => setSelectedStatus3(e.target.value)}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    title="Reporting Head Action Status"
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedRhStatus}
                                    onChange={(e) => {
                                        setSelectedRHStatus(e.target.value);
                                        setCheckedItems([]);
                                    }}
                                >
                                    <option value="null">All</option>

                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Office />
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    type="text"
                                    value={selectedDivision}
                                    onChange={(e) => setDivision(e.target.value)}
                                >
                                    <option value="null">All Sub Companies</option>
                                    {SubCompany.sort((a, b) => a.title - b.title).map(
                                        (i, index) => (
                                            <option value={i.id}>{i.title}</option>
                                        )
                                    )}
                                    ;
                                </select>

                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
                            </div>
                            <div title="Vehicle Filter" className="field-cont-div ">
                                <SelectVehical />
                                <select
                                    id="vehicle"
                                    name="vehicle"
                                    placeholder="vehicle"
                                    value={vehicle}
                                    onChange={(e) => setVehicle(e.target.value)}
                                    className={`attendance-input-field width-10vw`}
                                >

                                    <option value="null">Select Vehicle</option>
                                    {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.id}>{i.name}-{i.vehicle_num}</option>
                                    ))}
                                </select>


                            </div>
                        </div>
                        <div className="btn-cont"><DownloadVehicleBill projectList={officeBillings} />

                        </div>
                    </div>

                    <div className="table-css-white-background scroll-container-table">
                        <div className="table-heading-flex">
                            <div className="repo-heading font-weight500    font-size-heading">Admin Vehicle Billing Details</div>
                            <div className="flex-row">
                                {/* {(checkedItems.length > 0) ?
                                    <>
                                        <div className="align-center">
                                            <div className=" font-size-heading">{`Selected : ${checkedItems.length}`} </div>
                                        </div>
                                        <hr className="field-cont-hr" />
                                        {selectedRhStatus === "approved" && selectedStatus === "pending" ?
                                            <>
                                                <button className="model-button model-button-cancel   font-weight500"
                                                    onClick={handleFormSubmitApprovePut}
                                                >
                                                    Accept
                                                </button>

                                            </> : null}

                                    </>
                                    : null
                                } */}

                            </div>
                        </div>
                        <table className="table-css">
                            <thead className="table-heading stciky-heading-top">
                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text text-left-sr">S.No.</th>
                                    {/* {
                                        selectedRhStatus === "approved" && selectedStatus === "pending" ?
                                            <th className="align-left">
                                                <input
                                                    type="checkbox"
                                                    checked={(checkedItems.length > 0) ? true : false}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            const ids = officeBillings?.map((data) => data.id);
                                                            setCheckedItems(ids);
                                                        } else {
                                                            setCheckedItems([]);
                                                        }
                                                    }}
                                                />
                                            </th>
                                            : null
                                    } */}
                                    <th className="table-heading-text">Project Name</th>
                                    <th className="table-heading-text">Vehicle Name</th>
                                    <th className="table-heading-text">Vehicle Number</th>
                                    <th className="table-heading-text">Date</th>
                                    <th className="table-heading-text">Days</th>
                                    <th className="table-heading-text">Months</th>
                                    <th className="table-heading-text">Year</th>
                                    <th className="table-heading-text">Fixed Kilometer</th>
                                    <th className="table-heading-text">Fixed Bill Amount</th>
                                    <th className="table-heading-text text-center ">
                                        Extra Amount Per KM <br /> After Fixed KM
                                    </th>
                                    <th className="table-heading-text">Status</th>
                                    <th className="table-heading-text">Remarks</th>
                                    <th className="table-heading-text text-center">Actions</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <div className="spinner-bgdatil"></div>
                            ) : (
                                <tbody>
                                    {officeBillings !== undefined &&
                                        officeBillings.map((i, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="custom-table-head-td">
                                                    <td className="table-body text-left-sr">
                                                        {index + 1}
                                                    </td>
                                                    {/* {selectedRhStatus === "approved" && selectedStatus === "pending" ?
                                                        <td className="text-left">
                                                            <input
                                                                type="checkbox"
                                                                checked={checkedItems.indexOf(i.id) !== -1}
                                                                onChange={() => handleCheckboxChange(i.id)}
                                                            />
                                                        </td>
                                                        : null} */}
                                                    <td className="table-body">
                                                        {i?.vehicle_details?.project_short_name}
                                                    </td>
                                                    <td className="table-body">{i.vehicle_name}</td>
                                                    <td className="table-body">{i.vehicle_num}</td>
                                                    <td className="table-body">
                                                        {i.date ? formatDate(i.date) : "-"}
                                                    </td>
                                                    <td className="table-body">{i.days}</td>
                                                    <td className="table-body">
                                                        {getMonthName(i.month)}
                                                    </td>
                                                    <td className="table-body">{i.year}</td>
                                                    <td className="table-body text-center">
                                                        {i.fixed_km}
                                                    </td>
                                                    <td className="table-body text-center">
                                                        {formatCurrencyIndian(i.fixed_bill_amt)}
                                                    </td>
                                                    <td className="table-body text-center">
                                                        {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                                    </td>
                                                    <ViewRequestStatus
                                                        i={i}
                                                        approval_stages_data={i?.approval_stages_data}
                                                    />

                                                    <ViewRequestRemarks
                                                        i={i}
                                                        table="vehicle"
                                                        approval_stages_data={i?.approval_stages_data}
                                                    />

                                                    <td className="table-body">

                                                        {(i?.approval_stages_data?.admin1 || i?.approval_stages_data?.admin2 || i?.approval_stages_data?.admin3) && (
                                                            <div className="flex-row" style={{ justifyContent: "center" }}>

                                                                {(() => {
                                                                    const sessionEmpCode = sessionStorage.getItem("sitemanagement_emp_code");

                                                                    // Check if this employee has already approved a request
                                                                    const hasUserAlreadyApproved =
                                                                        sessionEmpCode === i.admin_update_by_c1 ||
                                                                        sessionEmpCode === i.admin_update_by_c2 ||
                                                                        sessionEmpCode === i.admin_update_by_c3;

                                                                    // Check if employee is assigned in approval_stages_data
                                                                    const isUserAssigned =
                                                                        sessionEmpCode === i?.approval_stages_data?.admin1_emp ||
                                                                        sessionEmpCode === i?.approval_stages_data?.admin2_emp ||
                                                                        sessionEmpCode === i?.approval_stages_data?.admin3_emp;

                                                                    // Function to render approval buttons for a specific admin
                                                                    const renderApprovalButtons = (adminNum, empCode, updateBy, approvalStatus) => {
                                                                        if (hasUserAlreadyApproved) return null; // Hide if employee has already approved or is assigned

                                                                        if (empCode === null || sessionEmpCode === empCode) {
                                                                            if (!updateBy && approvalStatus !== "approved" && approvalStatus !== "rejected") {
                                                                                return (
                                                                                    <div className="flex-row">
                                                                                        <ApprovedVehicleBillingAdminC1
                                                                                            i={i}
                                                                                            getofficebillingdata={getofficebillingdata}
                                                                                            documentlist={i?.documents}
                                                                                        />
                                                                                        <RejectVehicleBillingAdminC1
                                                                                            i={i}
                                                                                            getofficebillingdata={getofficebillingdata}
                                                                                            documentlist={i?.documents}
                                                                                        />
                                                                                    </div>
                                                                                );
                                                                            }
                                                                        }
                                                                        return null;
                                                                    };

                                                                    // Render approval options for only one admin at a time, ensuring same user can't act twice
                                                                    return (
                                                                        renderApprovalButtons(1, i?.approval_stages_data?.admin1_emp, i.admin_update_by_c1, i.admin_approval_status_c1) ||
                                                                        renderApprovalButtons(2, i?.approval_stages_data?.admin2_emp, i.admin_update_by_c2, i.admin_approval_status_c2) ||
                                                                        renderApprovalButtons(3, i?.approval_stages_data?.admin3_emp, i.admin_update_by_c3, i.admin_approval_status_c3)
                                                                    );
                                                                })()}
                                                            </div>
                                                        )}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

const VehicleBillingAccManagement = () => {
    const [toggleState, setToggleState] = useState(1);

    const gettitles = () => {
        switch (toggleState) {
            case 1:
                return "Vehicle Billing AccStage1";
            case 2:
                return "Vehicle Billing AccStage2";

            default:
                return "Vehicle Billing AccStage1";
        }
    };

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <Dashboardnavbar name={gettitles()} url="Admin Requests Management" />
            <div className="content-tabs">
                {/* <TeamRequestManagment secondtoggle={secondtoggle} /> */}
                <>
                    <div>
                        <div className="bloc-tabs-with-white-bg">
                            <button
                                className={
                                    toggleState === 1
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(1)}
                            >
                                Vehicle Billing AccStage1
                            </button>

                            <button
                                className={
                                    toggleState === 2
                                        ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                        : "dashboardcomponent-tabs  font-weight400  font-size-subheading   white-tab"
                                }
                                onClick={() => setToggleState(2)}
                            >
                                Vehicle Billing AccStage2
                            </button>
                        </div>

                        <div className="content-tabs-without-margin">
                            {toggleState === 1 ? <RequestVehicleBillingAccStage1 /> : null}
                            {toggleState === 2 ? <RequestVehicleBillingAccStage2 /> : null}
                        </div>
                    </div>
                </>
            </div>
        </>
    );
};

const RequestVehicleBillingAccStage1 = () => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [vehicle, setVehicle] = useState("null");
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    //! ******************************API start***************************//

    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/vehiclebillingapiaccountstatusafilter/${selectedProject}/${selectedStatus}/${fromdate}/${vehicle}/`
            );
            if (res?.data?.bills) {
                setOfficeBillings(res.data.bills);
            } else {
                setOfficeBillings(res.data);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getofficebillingdata();
        getSubCompany();
    }, [fromdate, todate, selectedStatus, vehicle, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    const [vehicleList, setVehicleList] = useState([]);
    const getVehicle = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehicle-short/`);
            setVehicleList(veh.data);

        } catch (err) {
            //toast Logic
            if (err.response) {
                const errorData = err.response.data;

                if (typeof errorData.error === 'string') {
                    // Single error message
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    // Multiple error messages
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        } finally {
            setBuffering(false);// End Buffering
        }
    }

    useEffect(() => {
        getEmpcode();
        getVehicle();
    }, []);
    //! *********** Employee Details Api End ***********

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="attendance-history-cont">
                <div className="attendance-heading  font-weight500    font-size-heading">
                    {" "}
                </div>
                <div className="attendance-subcont">
                    <div className="field-cont">
                        <div className="field-cont-div">
                            <div className="date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="From Date"
                                    type="date"
                                    value={fromdate}
                                    onChange={(e) =>
                                        setFromDate(e.target.value === "" ? "null" : e.target.value)
                                    }
                                />
                            </div>

                            <hr className="field-cont-hr" />
                        </div>

                        {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="null">All</option>

                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Office />
                            <select
                                className="attendance-input-field width-10vw date-field"
                                type="text"
                                value={selectedDivision}
                                onChange={(e) => setDivision(e.target.value)}
                            >
                                <option value="null">All Sub Companies</option>
                                {SubCompany.sort((a, b) => a.title - b.title).map(
                                    (i, index) => (
                                        <option value={i.id}>{i.title}</option>
                                    )
                                )}
                                ;
                            </select>

                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
                        </div>
                        <div title="Vehicle Filter" className="field-cont-div ">
                            <CircularGrid />
                            <select
                                id="vehicle"
                                name="vehicle"
                                placeholder="vehicle"
                                value={vehicle}
                                onChange={(e) => setVehicle(e.target.value)}
                                className={`attendance-input-field width-10vw`}
                            >

                                <option value="null">Select Vehicle</option>
                                {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                    <option key={index} value={i.id}>{i.name}-{i.vehicle_num}</option>
                                ))}
                            </select>


                        </div>
                    </div>
                    <div className="btn-cont"></div>
                </div>

                <div className="table-css-white-background scroll-container-table">
                    {/* <div className="table-heading-flex">
                        <div className="repo-heading font-weight500    font-size-heading">Expense</div>
                        <div className="flex-row">
                        </div>
                    </div> */}
                    <table className="table-css">
                        <thead className="table-heading stciky-heading-top">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text text-left-sr">S.No.</th>
                                <th className="table-heading-text">Project Name</th>
                                <th className="table-heading-text">Vehicle Name</th>
                                <th className="table-heading-text">Vehicle Number</th>
                                <th className="table-heading-text">Date</th>
                                <th className="table-heading-text">Days</th>
                                <th className="table-heading-text">Months</th>
                                <th className="table-heading-text">Year</th>
                                <th className="table-heading-text">Fixed Kilometer</th>
                                <th className="table-heading-text">Fixed Bill Amount</th>
                                <th className="table-heading-text text-center ">
                                    Extra Amount Per KM <br /> After Fixed KM
                                </th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text text-center">Actions</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div>
                        ) : (
                            <tbody>
                                {officeBillings !== undefined &&
                                    officeBillings.map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="table-body text-lefttt">{index + 1}</td>
                                                <td className="table-body">
                                                    {i?.vehicle_details?.project_short_name}
                                                </td>
                                                <td className="table-body">{i.vehicle_name}</td>
                                                <td className="table-body">{i.vehicle_num}</td>
                                                <td className="table-body">
                                                    {i.date ? formatDate(i.date) : "-"}
                                                </td>
                                                <td className="table-body">{i.days}</td>
                                                <td className="table-body">{getMonthName(i.month)}</td>
                                                <td className="table-body">{i.year}</td>
                                                <td className="table-body text-center">{i.fixed_km}</td>
                                                <td className="table-body text-center">
                                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                                </td>
                                                <td className="table-body text-center">
                                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                                </td>
                                                <ViewRequestStatus
                                                    i={i}
                                                    approval_stages_data={i?.approval_stages_data}
                                                />

                                                <ViewRequestRemarks
                                                    i={i}
                                                    table="vehicle"
                                                    approval_stages_data={i?.approval_stages_data}
                                                />
                                                <td className="table-body">
                                                    {i?.approval_stages_data?.account && (
                                                        <div className="flex-row ">
                                                            <>
                                                                {i.account_status_a === "approved" ? (
                                                                    <></>
                                                                ) : (
                                                                    <ApproveRequestVehicleBillingAccStage1
                                                                        i={i}
                                                                        getofficebillingdata={getofficebillingdata}
                                                                        documentlist={i?.vehicle_details?.documents}
                                                                    />
                                                                )}
                                                            </>
                                                            <>
                                                                {i.account_status_a === "rejected" ? (
                                                                    <></>
                                                                ) : (
                                                                    <RejectRequestVehicleBillingAccStage1
                                                                        i={i}
                                                                        getofficebillingdata={getofficebillingdata}
                                                                        documentlist={i?.vehicle_details?.documents}
                                                                    />
                                                                )}
                                                            </>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

const RequestVehicleBillingAccStage2 = () => {
    const { PERMISSION_AUTHORITY } = usePermission();
    // *********** Employee Details Api Start ***********
    const [allemployee, setAllemployee] = useState([]);
    const [officeBillings, setOfficeBillings] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedProject, setProject] = useState("null");
    const [fromdate, setFromDate] = useState("null");
    const [todate, setToDate] = useState("null");
    const [vehicle, setVehicle] = useState("null"); const [vehicleList, setVehicleList] = useState([]);
    const getVehicle = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const veh = await axios.get(`${BASE_URL}/siteproject/vehicle-short/`);
            setVehicleList(veh.data);

        } catch (err) {
            //toast Logic
            if (err.response) {
                const errorData = err.response.data;

                if (typeof errorData.error === 'string') {
                    // Single error message
                    toast.error(`Error: ${errorData.error}`);
                } else if (typeof errorData === 'object' && errorData !== null) {
                    // Multiple error messages
                    Object.entries(errorData).forEach(([field, messages]) => {
                        messages.forEach(message => toast.error(`"${field}": ${message}`));
                    });
                } else {
                    toast.error('Error:- Failed to Process!');
                }
            } else {
                toast.error('Error processing your request.');
            }
        } finally {
            setBuffering(false);// End Buffering
        }
    }
    const [selectedDivision, setDivision] = useState(
        `${sessionStorage.getItem("sitemanagement_project_sub_company") || null}`
    );

    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); //buffering logic // End Buffering
        }
    };

    //! ******************************API start***************************//
    const getofficebillingdata = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/vehiclebillingapiaccountstatusbfilter/${selectedProject}/${selectedStatus}/${fromdate}/${vehicle}/`
            );
            if (res?.data?.bills) {
                setOfficeBillings(res.data.bills);
            } else {
                setOfficeBillings(res.data);
            }
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getofficebillingdata();
        getSubCompany();
    }, [fromdate, todate, selectedStatus, vehicle, selectedProject]);

    const getEmpcode = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/sitemanagement-fromemp/`
            );
            setAllemployee(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getEmpcode();
        getVehicle();
    }, []);
    //! *********** Employee Details Api End ***********

    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="attendance-history-cont">
                <div className="attendance-heading  font-weight500    font-size-heading">
                    {" "}
                </div>
                <div className="attendance-subcont">
                    <div className="field-cont">
                        <div className="field-cont-div">
                            <div className="date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="From Date"
                                    type="date"
                                    value={fromdate}
                                    onChange={(e) =>
                                        setFromDate(e.target.value === "" ? "null" : e.target.value)
                                    }
                                />
                            </div>

                            <hr className="field-cont-hr" />
                        </div>

                        {/* // <div className="field-cont-div">
                        //     <div className="date-uppercase ">
                        //         <input
                        //             className="attendance-input-field width-10vw   date-field date-field-filter"
                        //             placeholder="From Date"
                        //             type="date"
                        //             value={todate}
                        //             onChange={(e) => setToDate(e.target.value === "" ? "null" : e.target.value)}
                        //         />
                        //     </div>
                        //     <hr className="field-cont-hr" />
                        // </div> */}
                        <div className="field-cont-div">
                            <Filter />
                            <select
                                className="attendance-input-field width-10vw   date-field"
                                type="text"
                                value={selectedStatus}
                                onChange={(e) => setSelectedStatus(e.target.value)}
                            >
                                <option value="null">All</option>

                                <option value="pending">Pending</option>
                                <option value="approved">Approved</option>
                                <option value="rejected">Rejected</option>
                            </select>
                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Office />
                            <select
                                className="attendance-input-field width-10vw date-field"
                                type="text"
                                value={selectedDivision}
                                onChange={(e) => setDivision(e.target.value)}
                            >
                                <option value="null">All Sub Companies</option>
                                {SubCompany.sort((a, b) => a.title - b.title).map(
                                    (i, index) => (
                                        <option value={i.id}>{i.title}</option>
                                    )
                                )}
                                ;
                            </select>

                            <hr className="field-cont-hr" />
                        </div>
                        <div className="field-cont-div">
                            <Projects usedFor="filter" value="id" toggleProject={selectedProject} setToggleProject={setProject} subcompany={selectedDivision} />
                        </div>
                        <div title="Vehicle Filter" className="field-cont-div ">
                            <CircularGrid />
                            <select
                                id="vehicle"
                                name="vehicle"
                                placeholder="vehicle"
                                value={vehicle}
                                onChange={(e) => setVehicle(e.target.value)}
                                className={`attendance-input-field width-10vw`}
                            >

                                <option value="null">Select Vehicle</option>
                                {vehicleList?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (
                                    <option key={index} value={i.id}>{i.name}-{i.vehicle_num}</option>
                                ))}
                            </select>


                        </div>
                    </div>
                    <div className="btn-cont"></div>
                </div>

                <div className="table-css-white-background scroll-container-table">
                    <table className="table-css">
                        <thead className="table-heading stciky-heading-top">
                            <tr className="custom-table-head-tr">
                                <th className="table-heading-text text-left-sr">S.No.</th>
                                <th className="table-heading-text">Project Name</th>
                                <th className="table-heading-text">Vehicle Name</th>
                                <th className="table-heading-text">Vehicle Number</th>
                                <th className="table-heading-text">Days</th>
                                <th className="table-heading-text">Months</th>
                                <th className="table-heading-text">Year</th>
                                <th className="table-heading-text">Fixed Kilometer</th>
                                <th className="table-heading-text">Fixed Bill Amount</th>
                                <th className="table-heading-text text-center ">
                                    Extra Amount Per KM <br /> After Fixed KM
                                </th>
                                <th className="table-heading-text">Status</th>
                                <th className="table-heading-text">Remarks</th>
                                <th className="table-heading-text text-center">Actions</th>
                            </tr>
                        </thead>
                        {buffer ? (
                            <div className="spinner"></div>
                        ) : (
                            <tbody>
                                {officeBillings !== undefined &&
                                    officeBillings.map((i, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="custom-table-head-td">
                                                <td className="table-body text-lefttt">{index + 1}</td>
                                                <td className="table-body">
                                                    {i?.vehicle_details?.project_short_name}
                                                </td>
                                                <td className="table-body">{i.vehicle_name}</td>
                                                <td className="table-body">{i.vehicle_num}</td>
                                                <td className="table-body">{i.days}</td>
                                                <td className="table-body">{getMonthName(i.month)}</td>
                                                <td className="table-body">{i.year}</td>
                                                <td className="table-body text-center">{i.fixed_km}</td>
                                                <td className="table-body text-center">
                                                    {formatCurrencyIndian(i.fixed_bill_amt)}
                                                </td>
                                                <td className="table-body text-center">
                                                    {formatCurrencyIndian(i.extra_amt_above_fix_km)}
                                                </td>
                                                <ViewRequestStatus
                                                    i={i}
                                                    approval_stages_data={i?.approval_stages_data}
                                                />

                                                <ViewRequestRemarks
                                                    i={i}
                                                    table="vehicle"
                                                    approval_stages_data={i?.approval_stages_data}
                                                />
                                                <td className="table-body">
                                                    {i?.approval_stages_data?.payment_settlement && (
                                                        <div className="flex-row ">
                                                            <>
                                                                {i.account_status_b === "approved" ? (
                                                                    <></>
                                                                ) : (
                                                                    <ApproveRequestVehicleBillingAccStage2
                                                                        i={i}
                                                                        getofficebillingdata={getofficebillingdata}
                                                                        documentlist={i?.vehicle_details?.documents}
                                                                    />
                                                                )}
                                                            </>
                                                            {/* <>

     {i.account_status_b === "rejected" ? (
         <></>
     ) : (
         <RejectRequestVehicleBillingAccStage2
             i={i}
             getofficebillingdata={getofficebillingdata}
             documentlist={i?.vehicle_details?.documents}
         />
     )}

 </> */}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
        </>
    );
};

export {
    RequestVehicleBillingChecker,
    RequestVehicleBillingAuthority,
    RequestVehicleBillingAdmin,
    VehicleBillingAccManagement,
    RequestVehicleBillingAccStage1,
    RequestVehicleBillingAccStage2,
};
